import request from '@/utils/request';

/**
 * @description 查询服务列表
 * @param keyword
 * @param itemStatus
 * @param kdtId
 * @param pageNum
 * @param pageSize
 */
function queryServiceList({ keyword, thirdId, itemStatus, kdtId, pageNum, pageSize } = {}) {
  return request({
    url: 'serving/item/pageQueryServingItemBriefInfo',
    method: 'get',
    params: {
      keyword,
      thirdId,
      itemStatus,
      pageNum,
      pageSize
    },
    kdtId,
    isKdtId: true
  });
}

export default {
  queryServiceList
};
